import { Component, OnInit, Input, Output, EventEmitter, ViewChild, TemplateRef, ViewChildren, QueryList, ChangeDetectorRef } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { DataTablesModule, DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';
import { Router } from '@angular/router';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { environment } from '../../../../../../environments/environment';;
import { LoaderService } from '../../../../../shared/providers/loader.service';
import { AuthenticationService } from '../../../../../shared/auth/authentication.service';
import { DataTablesResponse } from '../../../../../shared/models/datatables-response';
import { ValidationService } from '../../../../../shared/providers/validation.service';
import { ProspectModel } from '../../../../../shared/models/ProspectModel';

export interface ISort {
  SortColumn: number,
  SortOrder: string
}

@Component({
  selector: 'app-prospect-preview',
  templateUrl: './prospect-preview.html',
  styleUrls: ['./prospect-preview.css']
})
export class ProspectPreview implements OnInit {
  @Input() propertyId: number;
  @Output() close = new EventEmitter();
  @Output() save = new EventEmitter();
  activePage: number
  removeModalRef: BsModalRef;
  user: any;
  selectedColumns = [];
  statusIDs = [];
  feedbackIds = [];
  //defaultTypeText: IMultiSelectTexts = {
  //  defaultTitle: 'Select Columns',
  //};
  defaultTypeSettings = {
    dynamicTitleMaxItems: 1,
    fixedTitle: 'Select Columns',
  }

  isAdmin: boolean;
  dtOptions = {};
  lstProspects = [] as ProspectModel[]
  @ViewChild('template') template: TemplateRef<any>;
  @ViewChild(DataTableDirective) dtElement: DataTableDirective;
  protected readonly BASE_URL: string = environment.base_url;

  dtTrigger: Subject<any> = new Subject();
  table: DataTableDirective;

  constructor(private http: HttpClient,
    private _modalService: BsModalService,
    private _loaderService: LoaderService,
    private _authenticationService: AuthenticationService,
    private router: Router, private cdRef: ChangeDetectorRef, private _validationService: ValidationService) { }

  ngOnInit() {
    this.user = this._authenticationService.user;
    this.getProspectList();
  }

  convertUTCDateToLocalOfferDate(OfferDate: Date) {
    var newDate = new Date(OfferDate);
    var offset = newDate.getTimezoneOffset() / 60;
    var offsetTime = new Date(newDate.getTime() - (offset * 60 * 1000 * 60));
    return offsetTime;
  }

  onClose() {
    this.close.emit();
  }

  onSave(sort) {
    this.save.emit(sort);
  }

  dtInstance: any;

  getProspectList() {
    const that = this;
    let columns = [
      { data: 'ProspectName' },
      { data: 'ProspectName' },
      { data: 'ModifiedDate' },
      { data: 'CompanyName' },
      { data: 'OMDownloads' },
      { data: 'NDAExecuted' },
      { data: 'OfferOn' },
      { data: 'StatusName' },
      { data: 'FeedbackName' }, { data: 'Notes' }]
    this.dtOptions = {
      pagingType: 'full_numbers',
      serverSide: true,
      processing: true,
      info: false,
      language: {
        zeroRecords: null,
      },
      "pageLength": 50,
      "order": [[1, "desc"]],
      bLengthChange: false,
      initComplete: () => $('.dataTables_filter').css('display', 'none'),
      ajax: (dataTablesParameters: any, callback: Function) => {

        dataTablesParameters.Extra_param = {
          PropertyId: this.propertyId,
          ProspectStatusId: that.statusIDs,
          ProspectFeedbackId: that.feedbackIds
        }
        const httpHeader = this._validationService.GetAuthHeader();
        that.http
          .post<DataTablesResponse>(
            this.BASE_URL + '/Property/GetAllProspectsForPreview',
            dataTablesParameters, httpHeader
          ).subscribe(resp => {
            that.lstProspects = resp.data ? resp.data : [];
            let sortColumn = (resp.data && resp.data.length > 0) ? resp.data.find(p => p.SortColumn != null).SortColumn : 0;
            let sortOrder = (resp.data && resp.data.length > 0) ? resp.data.find(p => p.SortOrder != null).SortOrder : 'asc';
            let sort: ISort = { SortColumn: sortColumn, SortOrder: sortOrder };
            this.onSave(sort);
            if (that.lstProspects.length > 0) {
              that.lstProspects.forEach(item => {
                if (item.Notes != null && item.Notes != '') {
                  if (item.Notes.trimEnd().length > 25) {
                    item.ShortDescription = item.Notes.slice(0, 25) + ' . . .';
                  }
                }
              });
            }
            if (resp) {
              callback({
                recordsTotal: resp.recordsTotal,
                recordsFiltered: resp.recordsFiltered,
                data: []
              });
              if (resp.data.length === 0) {
                $(".dataTables_paginate.paging_full_numbers").hide();
              }
              else {
                $(".dataTables_paginate.paging_full_numbers").show();
              }
              $(".paginate_button.first,.paginate_button.last").hide();
            } else {
              callback({
                recordsTotal: 0,
                recordsFiltered: 0,
                data: []
              });
              $(".dataTables_paginate.paging_full_numbers").hide();
            }
          });
      },
      columns: columns
    };
  }

}

